import "./global";
import { generateUserIdentitySignature } from "./utils/signing";

const CDN_URL = "https://cdn.userjot.com/sdk/v1/uj.js";

export type InitOptions = {};

export type IdentifyOptions = {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  avatar?: string;
};

export interface IUserJot {
  /**
   * Initializes the widget.
   * @param projectId - The project id.
   * @param options - The options for the widget.
   */
  init(projectId: string, options?: InitOptions): void;

  /**
   * Sets the user id.
   * @param options - The options for the user.
   */
  identify(options: IdentifyOptions | null): void;

  /**
   * Sets a property for the user.
   * @param key - The key of the property.
   * @param value - The value of the property.
   */
  setProperty(key: string, value: string | number | boolean | null): void;

  /**
   * Destroys the widget.
   */
  destroy(): void;
}

export { CDN_URL, generateUserIdentitySignature };
